<app-header></app-header>
<router-outlet></router-outlet>
<privacy-policy-modal></privacy-policy-modal>
<app-footer></app-footer>
